module.exports = __webpack_public_path__ + "img/14_3.5344729b.png";